import { useContext } from 'react';
import { ConfigContext } from '@common/Config';
import { useTranslation } from '@common/Hooks/useTranslation';
import { GA_EVENT_TOP_NAVIGATION_CLICK } from '@common/Tracking';
import { menuSelectItemListTracking } from '@common/Tracking/Navigation';
import { pushGAEventToDataLayer } from '@helpers/dataLayer';
import { isNavConfigEnabled } from '@helpers/navigation';
import { getTranslatedPropertyFromContext } from '@helpers/translationContext';

export function useMainHeaderNavBar(topMenuTree, setSelectedDepartment) {
    const config = useContext(ConfigContext);
    const { URLPrefix } = config;
    const translate = useTranslation();

    const handleMainHeaderNavBarLinkClick = (event, menuItem) => {
        pushGAEventToDataLayer(GA_EVENT_TOP_NAVIGATION_CLICK, menuItem.name, 'No sub category');
        const selectedDepartment = { id: event, name: menuItem.languageContext.en?.name };
        setSelectedDepartment(selectedDepartment);
        menuItem.lvl = 1;
        menuSelectItemListTracking(menuItem, selectedDepartment);

        return true;
    };

    const getHref = (navItem, banner) => {
        if (navItem.type === 'link') { return navItem.url; }

        const localizedUrl = getTranslatedPropertyFromContext(navItem, 'url', config);

        return localizedUrl && banner === null ? `${URLPrefix}${localizedUrl}` : '';
    };

    const mainHeaderNavBarItems = topMenuTree.map((navItem) => {
        const {
            banner, isNew, idNameSlug, type, children
        } = navItem;
        const isExternal = type === 'link';

        return {
            ...navItem,
            attributes: {
                'data-cs-id': idNameSlug
            },
            url: !isNavConfigEnabled(navItem, 'disableLinking') ? getHref(navItem, banner) : undefined,
            label: getTranslatedPropertyFromContext(navItem, 'name', config),
            isExternal,
            ...isNew && { tag: translate('navigation.new_tag') },
            hasChildren: children.length > 0,
            hasDropdown: !isNavConfigEnabled(navItem, 'desktopNavigationDropdownHide')
        };
    });

    return { handleMainHeaderNavBarLinkClick, mainHeaderNavBarItems };
}
